import 'css-chunksrc/client/pages/projectPage/menu/styles.scss';export default {
  "menu": "_menu_bw7dv_1",
  "main": "_main_bw7dv_9",
  "wrapper": "_wrapper_bw7dv_20",
  "name": "_name_bw7dv_30",
  "icon": "_icon_bw7dv_43",
  "projectModelIcon": "_projectModelIcon_bw7dv_50",
  "toggleArrow": "_toggleArrow_bw7dv_56",
  "open": "_open_bw7dv_64",
  "list": "_list_bw7dv_71",
  "item": "_item_bw7dv_83",
  "dangerous": "_dangerous_bw7dv_95",
  "inactive": "_inactive_bw7dv_99"
};